/**
 * Checks if the object has any keys.
 * @param obj - The object to check.
 * @returns True if the object has any keys, false otherwise.
 */

export function isValidObject(obj: object): boolean {
    return obj !== null && typeof obj === 'object' && Object.keys(obj).length > 0;
}
